import { render, staticRenderFns } from "./rulesText.vue?vue&type=template&id=3f263eb7"
import script from "./rulesText.vue?vue&type=script&lang=js"
export * from "./rulesText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports